<script lang="ts" setup>
import { defineEmits, defineProps, getCurrentInstance, ref } from 'vue'
import { VueEditor } from 'vue2-editor'
import BKEditorConfig from '@/common/vue2Config'
import { Organization } from '@/modules/Organizations/types'
import BKCheckbox from '@/components/AppShared/BKCheckbox.vue'

const instance = getCurrentInstance()

const props = defineProps<{
  org: Organization
  isLoading: boolean
}>()

const emit = defineEmits<{
  (e: 'update'): void
}>()

const mask = ref('##/##/####')
const editorConfig = ref(BKEditorConfig)

function updateGeneralInfo() {
  console.log(props.org)
  if (props.org.description) {
    props.org.description = instance?.proxy?.$sanitize(props.org.description)
  }
  emit('update')
}
</script>

<template>
  <div class="settings-general">
    <div class="fields">
      <div class="field">
        <v-text-field
          v-model="org.name"
          hide-details
          label="Organization name"
          outlined
        />
      </div>

      <div class="field">
        <v-text-field
          v-model="org.founded"
          v-mask="mask"
          hide-details
          label="Date created"
          outlined
        />
      </div>
      <div class="field">
        <VueEditor
          v-model="org.description"
          :editor-toolbar="editorConfig"
          label="Description"
        />
      </div>

      <div class="field">
        <BKCheckbox
          :value="org.rankingDisabled"
          class="mb-6"
          label="Disable ranking"
          @change="(value) => (org.rankingDisabled = value)"
        />
      </div>
    </div>

    <div class="options">
      <v-btn
        :loading="isLoading"
        color="var(--color-blue-800)"
        dark
        height="52"
        width="180"
        @click="updateGeneralInfo"
      >
        Save
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.settings-general {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}

.fields {
  padding: 20px;

  .field {
    margin-bottom: 16px;

    ::v-deep .ql-container {
      max-height: 275px;
      overflow: auto;
    }
  }
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding: 20px;
  border-top: 1px solid var(--color-grey-600);
}
</style>
